import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { withNamespaces } from 'react-i18next';
import Projects from 'apps/projects/projects';
import { RouterProps } from 'types';
import { MainWrapper } from 'legacyComponents/styled/lib';

const viewsMap = {
  '': Projects,
};

@withNamespaces()
@observer
class WithProjectsRouter extends React.Component<RouterProps> {
  render() {
    const View = this.props.componentFromRoute();

    return (
      <MainWrapper>
        <View params={this.props.params} />
      </MainWrapper>
    );
  }
}

export const SharedWithProjectsRouter = routeNode(
  'workspace.sharedWithProjects',
  viewsMap,
  FourOhFour as unknown as boolean,
)(WithProjectsRouter);
